import { Image16 } from 'ui/icons';

import { useSideBySideEditorContext } from '../../../contexts/SideBySideEditorContext';
import { testIds } from '../../../constants';
import { useHandleImageModal } from '../../../hooks/useHandleImageModal';
import { useTranslations } from '../../../hooks/useTranslations';
import { getCurrentElementRange, getCurrentElement } from '../../../utils';
import { ToolbarButton } from './BaseInsertButton';

export const CreativeLibraryButton = () => {
  const { t } = useTranslations();
  const { editor } = useSideBySideEditorContext();
  const handleImageModal = useHandleImageModal();

  const onClick = () => {
    const thisEditor = editor.current;
    if (thisEditor) {
      const eltRange = getCurrentElementRange(thisEditor);
      const elt = eltRange ? getCurrentElement(thisEditor, eltRange) : undefined;

      handleImageModal(eltRange, elt?.tagName === 'IMG' ? (elt as HTMLImageElement) : undefined);
    }
  };

  return (
    <ToolbarButton
      onClick={onClick}
      testId={testIds.toolbarBtnCreativeLib}
      tooltip={t('tooltip.buttonImage')}
    >
      <Image16 isColorInherited />
      <span>{t('button.images')}</span>
    </ToolbarButton>
  );
};
